import { Full } from 'types/common';
import * as Yup from 'yup';

export interface IMerchantAddForm {
  name: string;
  merchant?: { label: string; value: string };
}

export type TSubmittedValues = Full<IMerchantAddForm>;

export const initialValues: IMerchantAddForm = {
  name: '',
  merchant: undefined,
};

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('validation.required'),
  merchant: Yup.mixed().required('validation.required'),
});
